import { Loader2 } from 'lucide-react';
import React from 'react';

interface SmoothLoadingProps {
  message?: string;
  subMessage?: string;
}

const SmoothLoading: React.FC<SmoothLoadingProps> = ({
  message = 'Loading Device...',
  subMessage = 'Please wait while we set up your display',
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
      <div className="text-center">
        <div className="relative">
          <Loader2 className="w-16 h-16 text-blue-600 animate-spin mx-auto mb-6" />
          <div className="absolute inset-0 w-16 h-16 border-4 border-blue-200 rounded-full animate-pulse mx-auto"></div>
        </div>
        <h2 className="text-2xl font-semibold text-gray-800 mb-2">{message}</h2>
        <p className="text-gray-600 animate-pulse">{subMessage}</p>
        <div className="mt-6 flex justify-center space-x-1">
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"></div>
          <div
            className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"
            style={{ animationDelay: '0.1s' }}
          ></div>
          <div
            className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"
            style={{ animationDelay: '0.2s' }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default SmoothLoading;
